import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { reviewData } from '../review-data';

@Component({
  selector: 'star-reviews',
  templateUrl: './star-reviews.component.html',
  styleUrls: ['./star-reviews.component.scss'],
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
})
export class StarReviewsComponent {
  @Input() backgroundInfo: any;
  @Input() textColorValue: string;
  @Input() textColorOverride: string;
  @Input() containerClasses: string;
  @Input() title: string;
  faStar = faStar;
  fiveStars = [1, 2, 3, 4, 5];
  starsReviews = reviewData[0];

  constructor() {}
}
